import { render } from "./PageRenderer.vue?vue&type=template&id=0caa6a1e"
import script from "./PageRenderer.vue?vue&type=script&lang=js"
export * from "./PageRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/PEP/PEP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__